import React from "react";

interface ITitlePageProps {
  title: string;
  defaultNameProduct?: string;
}

const TitlePage = ({ title, defaultNameProduct }: ITitlePageProps) => (
  <head>
    <title>
      {defaultNameProduct} - {title}
    </title>
  </head>
);

TitlePage.defaultProps = {
  defaultNameProduct: "Logan",
};

export default TitlePage;
